export const priceWithVATRounded = (
  number: string,
): string => String((Number(number) * 1.1).toFixed(2));
